import { api } from "@/lib/api";

export const fmtT = (n) =>
  Number(n || 0).toLocaleString("es-AR", { minimumFractionDigits: 1, maximumFractionDigits: 1 });
export const fmtN = (n) =>
  Number(n || 0).toLocaleString("es-AR", { maximumFractionDigits: 2 });

export const GREEN = "#0f5233";

export async function downloadFile(path, filename, params = {}) {
  const res = await api.get(path, { params, responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

export const ESTADO_STYLE = {
  Atrasado: "bg-red-100 text-red-700",
  "En curso": "bg-amber-100 text-amber-700",
  Cumplido: "bg-emerald-100 text-emerald-700",
  "Sin análisis": "bg-slate-100 text-slate-500",
};
export const FIRMA_STYLE = { Sí: "text-emerald-700", No: "text-red-600", "Sin dato": "text-slate-400" };

export const miles = (n) => Math.round(Number(n) || 0).toLocaleString("es-AR");

export const CBOT_FALLBACK = [
  { key: "soja", label: "Soja" }, { key: "maiz", label: "Maíz" }, { key: "trigo", label: "Trigo" },
];

// Conversión Chicago ¢/bu -> USD/t: la calcula SOLO el backend (/api/granos/cbot -> item.usd_t).
export function cultKey(c) {
  const n = (c || "").toString().toLowerCase();
  if (n.includes("soja") || n.includes("soya")) return "soja";
  if (n.includes("trig")) return "trigo";
  if (n.includes("ma") && n.includes("z")) return "maiz";
  return null;
}
export function cbotUsdT(cultivo, items) {
  const k = cultKey(cultivo);
  if (!k) return null;
  const it = (items || []).find((i) => i.key === k && i.price != null);
  return it && it.usd_t != null ? Number(it.usd_t) : null;
}
